import React, { FC, useEffect, useState } from 'react';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { getCommentariesByDocId } from '../../../decision/decision.api';
import { trackCommentary } from '../../commentary.api';
import { CommentaryModalContent } from '../../modal/CommentaryModalContent';
import { Commentary } from '../../commentary.types';

type Props = {
  docId: string;
  isOpen: boolean;
  onRequestClose: () => void;
  source: string;
  trackingEventName: string;
};

export const CommentariesModal: FC<Props> = ({
  docId,
  isOpen = false,
  onRequestClose = () => {},
  source,
  trackingEventName,
}) => {
  const [commentaries, setCommentaries] = useState<Array<Commentary>>([]);

  useEffect(() => {
    async function fetchCommentaries() {
      try {
        const { data } = await getCommentariesByDocId(docId);
        setCommentaries(data);
      } catch (error) {
        throw error;
      }
    }
    fetchCommentaries();
  }, []);

  const commentaryClicked = (commentary: Commentary, index: number) => {
    if (commentary.typeLabel !== 'PAPER') {
      doctrineAnalytics(trackingEventName, {
        ...commentary,
        docId,
        articleId: commentary.commentaryId,
        source,
      });
      trackCommentary(commentary.url, source, {
        position: index,
        doc_id: commentary.commentaryId,
      });
    }
  };

  return (
    <CommentaryModalContent
      isOpen={isOpen}
      commentaries={commentaries}
      closeModal={onRequestClose}
      commentaryClicked={commentaryClicked}
      source={source}
    />
  );
};
